/**
 * UTM Service
 * Captures UTM parameters from URL and persists them for outbound links.
 */

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
const STORAGE_KEY = 'fpt_utm';

export const initUtm = () => {
  const params = new URLSearchParams(window.location.search);
  const utmData: Record<string, string> = {};
  let found = false;

  UTM_KEYS.forEach(key => {
    const value = params.get(key);
    if (value) {
      utmData[key] = value;
      found = true;
    }
  });

  if (found) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(utmData));
  }
};

export const appendUtm = (url: string): string => {
  if (!url || !url.startsWith('http')) return url;

  const stored = localStorage.getItem(STORAGE_KEY);
  if (!stored) return url;

  try {
    const utmData = JSON.parse(stored);
    const urlObj = new URL(url);
    
    Object.entries(utmData).forEach(([key, value]) => {
      urlObj.searchParams.set(key, value as string);
    });

    return urlObj.toString();
  } catch (e) {
    console.error('Failed to append UTM:', e);
    return url;
  }
};
